import React, { ReactNode } from 'react'

/** Отступ заглушки от контента над ней — фильтров, табов, тулбара. Один на все заглушки. */
export const STUB_OFFSET = 60

interface StubLayoutProps {
  children: ReactNode
  /** Сколько раскладка уже отступила от контента над заглушкой: gap колонки, padding и т. п. */
  gap?: number
}

/** Ставит заглушку на единый отступ от контента над ней; сами заглушки сверху отступов не держат. */
export const StubLayout = ({ children, gap = 0 }: StubLayoutProps) => (
  <div style={{ paddingTop: STUB_OFFSET - gap }}>{children}</div>
)
